module.exports = __webpack_public_path__ + "img/slider_momento.d702e429.png";